import { type IAgxConfig, resolveAgxEnvironment } from '@urbanx/agx.auth.client';

function createLocalUrisFromConfig() {
  const metaEnv = import.meta.env ?? {};

  const localServiceUris = Object.keys(metaEnv)
    .filter((key) => key.startsWith('VITE_REACT_APP_LOCAL_SERVICE_URI_'))
    .map((key) => ({
      service: key.replace('VITE_REACT_APP_LOCAL_SERVICE_URI_', '').toLowerCase(),
      uri: metaEnv[key],
    }));

  if (localServiceUris.length === 0) return undefined;

  const localUris: Record<string, string> = {};

  localServiceUris.forEach((service) => {
    if (service.uri) {
      localUris[service.service] = service.uri;
    }
  });

  return localUris;
}

const envSigninPrefix = import.meta.env.VITE_REACT_APP_ENV_SIGNIN_PREFIX;

const AppConfig: IAgxConfig = {
  authClientId: import.meta.env.VITE_REACT_APP_AUTH_CLIENT_ID,
  authInstance: import.meta.env.VITE_REACT_APP_AUTH_INSTANCE,
  authDomain: import.meta.env.VITE_REACT_APP_AUTH_DOMAIN,
  authSignupSigninPolicyId: import.meta.env.VITE_REACT_APP_AUTH_SIGNIN_SIGNUP_POLICY_ID,
  envSigninPrefix,
  environment: resolveAgxEnvironment(envSigninPrefix),
  authEnableLogs: import.meta.env.VITE_REACT_APP_LOG_AUTH,
  baseApiUri: import.meta.env.VITE_REACT_APP_AGENTX_BASE_API,
  authAppUri: import.meta.env.VITE_REACT_APP_AGENTX_AUTH_APP_URI,

  devMode: import.meta.env.VITE_REACT_APP_DEV_MODE === 'true',

  userIdClaim: import.meta.env.VITE_REACT_APP_USERID_CLAIM,
  userTypeClaim: import.meta.env.VITE_REACT_APP_USERTYPE_CLAIM,
  agencyClaim: import.meta.env.VITE_REACT_APP_AGENCY_CLAIM,
  rolesClaim: import.meta.env.VITE_REACT_APP_ROLES_CLAIM,

  localUris: createLocalUrisFromConfig(),
};

export default AppConfig;
